import {APiUrbit} from '../../../../../services/api/apiUrbit'
import {FormAVM} from '../context/AvmContext'

export function useAvm() {
  async function syncAvm(data) {
    const api = new APiUrbit()
    const result = await api.post(`avm`, data)
    return result
  }

  async function syncAvmGam({
    dados,
    finalidade = 'venda',
    dummies = 'sd',
  }: {
    dados: FormAVM
    finalidade: 'venda' | 'alguel'
    dummies: 'sd' | 'cd'
  }) {
    
    dados['finalidade'] = finalidade
    dados['dummies'] = dummies
    let result = null
    try {
      const token = localStorage.getItem('api_token_api_gis') || localStorage.getItem('token') || ''
      const urbitApiUrl = (process.env.REACT_APP_URBIT_API_URL || '').replace(/\/?$/, '/')
      // `https://avm.urbit.com.br/predict?finalidade=${finalidade}&dummies=${dummies}`,
      const response = await fetch(`${urbitApiUrl}avm`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          // 'mode':'cors'
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(dados),
      })
      result = await response.json()
    } catch (error) {
      result = {service: 'error', message: error, itens: [], total: 0}
      console.error('Error:', error)
    }

    // const api = new APiUrbit()
    // const result = await api.post(`avm-usados`, data)
    return result
  }

  return {syncAvm, syncAvmGam}
}
